module.exports = __webpack_public_path__ + "static/media/Expand.97965020.svg";